import * as Utils from "../ts/rlAdmin.utils";
import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { ContractService } from "../services/contract-service";

export function RLFinancialValidation() {
	var directive: ng.IDirective = {
		restrict: "E",
		controller: RLFinancialValidationController,
		controllerAs: "fvVM",
		bindToController: true,
		template: require("/assets/app/templates/financial-validation.html"),
		scope: {
			entityId: "<",
		}
	};

	return directive;
}

class RLFinancialValidationController {
	static $inject = ["$scope", "contractService"];

	entityId: string;
	financialValidations: Models.IFinancialValidation;

	constructor(private $scope: ng.IScope, private contractService: ContractService) { }

	$onInit() {
		if (Utils.IdBuilder.splitEntityID(this.entityId).charTypeID === Consts.CharTypeIDs.transaction) {
			this.contractService.validateFinancials(this.entityId)
			.then((results) => {
					this.financialValidations = results;
				});
		}
	}
}